import { GetObjectHelperBase } from './GetObjectHelperBase';
export class GetInternalObjectHelper extends GetObjectHelperBase {
    constructor() {
        super(...arguments);
        this.index = 2;
    }
}

//# sourceMappingURL=GetInternalObjectHelper.js.map
